import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { VideoCallChip } from '@/features/jobs/details/components/JobTopBar/CallChip'

export interface CallChipContainerProps {
  vm: JobDetailsViewModel
}

/**
 * The always-on video room some jobs carry. A consultation shows its call in
 * the next step card instead.
 */
export const CallChipContainer = observer(function CallChipContainer({
  vm,
}: CallChipContainerProps) {
  if (vm.consultationVm.showCallCard && vm.consultationVm.roomVm.activeRoom) {
    return (
      <VideoCallChip
        isJoinDisabled={
          vm.consultationVm.roomVm.join.pending ||
          vm.consultationVm.roomVm.isRoomClosed
        }
        isJoinPending={vm.consultationVm.roomVm.join.pending}
        onJoin={vm.consultationVm.roomVm.join}
      />
    )
  }
  return null
})
